export const createPubSubPublishHandler = pubSub => (...args) => {
  pubSub.publish(...args);
};
